import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { useCallback, useContext, useMemo, useState } from "react";
import { PapsContext } from "../PapsContext";
import { useCachedData } from "./useCachedData";
import { _cacheGroupTypes } from "./useTimestamp";

const storageUrlCallTypes = {
  normal: 'normal',
};

export const useStorageUrls = () => {

  const papsContext = useContext(PapsContext);
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}

  const [_assetUrls, set_assetUrls] = useState()

  useCachedData({
    cache_groupType: _cacheGroupTypes.storageInfo,
    cache_key: eventKey,
    fetchers: [
      { key: storageUrlCallTypes.normal, getConfigFn: getConfig_storageUrls },
    ],
    updateLocalState: (data) => {
      _.forEach(data, (value, key) => {
        switch (key) {
          case storageUrlCallTypes.normal:
            const { global, pages, _timestamp } = value
            const assetUrls = { global, pages, _timestamp }
            set_assetUrls(assetUrls);
            break;
        }
      });
    }
  })

  const handleStorage_delete = useCallback(
  );

  const storageInfo = useMemo(
    () => ({ _assetUrls, handleStorage_delete }),
    [_assetUrls]
  );

  return storageInfo;
};

const getConfig_storageUrls = (pathViews, callback) => ({
  refPath: createRefPath_event(pathViews, ['_assetUrls']),
  callback,
  opts: { ignoreId: true },
});